import ko from "lib/knockout";
import {asString} from "../utils/var";
import {init as initQuickSearch} from "modules/shop/quicksearch/viewmodel";
import {CreateOrderForm} from "modules/packages/create_order/viewmodel";

export class MainInput {
	input = ko.observable('');
	inputFocus = ko.observable(false);
	active = ko.observable(false);

	_isOpened = ko.observable(false);
	_mode = ko.observable('');
	_processed = ko.observable(false);

	/** @type {JQuery.Callbacks} */
	onOpen = $.Callbacks();

	/** @type {QuickSearchViewModel} */
	quickSearch;
	/** @type {CreateOrderForm} */
	createOrder;

	_o = {};

	constructor(options) {
		const o = this._o = {
			value: '',

			containerSelector: '',
			autoScroll: true,

			searchEnabled: true,
			searchOptions: {},

			orderEnabled: true,
			orderOptions: {},
			orderCloseOnSuccess: true,
			orderFormSelector: '',

			...options
		};

		if (o.searchEnabled) {
			this.quickSearch = initQuickSearch(o.searchOptions);
		}

		if (o.orderEnabled) {
			this.createOrder = new CreateOrderForm(o.orderFormSelector, o);
			this.createOrder.onSuccess.add(() => {
				this.reset();
				if (o.orderCloseOnSuccess) {
					this.close();
				}
			});
		}

		this.input(o.value);

		this._isOpened.subscribe(state => {
			if (state) {
				this.onOpen.fire();
			}
		});
		this.input.subscribe(() => {
			this._processInput();
		});
		this.inputFocus.subscribe((value) => {
			if (value && this._processed()) {
				this.open();
			}
		});

		if (o.autoScroll) {
			this._initAutoScroll();
		}
	}

	/** @type {boolean} */
	get isOpened() {
		return this._isOpened();
	}

	/** @type {string} */
	get mode() {
		return this._mode();
	}

	handleSubmit() {
		if (this._mode() == 'search' && this._processed() && this._o.searchEnabled) {
			this.quickSearch.handleSubmit();
		} else {
			this._processInput();
		}
	}

	_processInput() {
		const input = asString(this.input()).trim();
		if (input.length < 3) {
			this._processed(false);
			return;
		}

		if (/^https?:\/\//i.test(input) && this._o.orderEnabled) {
			this._doCreateOrder();
		} else if (this._o.searchEnabled) {
			this._doSearch();
		}
		this._processed(true);
		this.open();
	}

	_doCreateOrder() {
		this._mode('order');
		this.createOrder.process(this.input());
	}

	_doSearch() {
		this._mode('search');
		this.quickSearch.criteria(this.input());
	}

	_initAutoScroll() {
		const scroll = () => {
			const $container = $(this._o.containerSelector);
			if ($container.length > 0) {
				const top = $container.offset().top - 40;
				$('body,html').animate({scrollTop: top}, 600);
			}
		};
		this.onOpen.add(scroll);
		if (!this._o.orderCloseOnSuccess) {
			this.createOrder.onSuccess.add(scroll);
		}
	}

	open() {
		this._isOpened(true);
	}

	close() {
		this._isOpened(false);
	}

	reset() {
		this.input('');
	}

    highlight() {
        this.active(true);
    }

    unhighlight() {
        if(!this.inputFocus()) {
            this.active(false);
        }
    }


	handleExampleSearchClick(item, e) {
		const value = $(e.target).text().trim();
		this.input(value);
		this.open();
	}

	handleExampleOrderClick(item, e) {
		const value = $(e.target).attr('href');
		this.input(value);
		this.open();
	}

	handleOverlayClick() {
		if (this._mode() != 'order') {
			this.close();
		}
	}
}



// WEBPACK FOOTER //
// ./core/components/maininput.js